import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { subscribe, cancel, dismiss, armAutoResume, UploadProgress } from '../services/uploadManager';

// The folder-upload progress card, mounted in the APP SHELL rather than inside the File Library, so
// it follows the operator across every module (owner 2026-08-24: "不管在什么页面，都可以继续上传").
// It also arms the auto-resume once per tab — the shell is the only place guaranteed to be mounted.
export default function UploadIndicator() {
  const { t } = useTranslation();
  const [p, setP] = useState<UploadProgress | null>(null);
  useEffect(() => subscribe(setP), []);
  useEffect(() => { void armAutoResume(); }, []);

  if (!p) return null;
  const pct = p.total ? Math.round((p.done / p.total) * 100) : 0;
  const complete = !p.running && p.done >= p.total;
  const btn: React.CSSProperties = { padding: '3px 10px', fontSize: 12, borderRadius: 7, border: '1px solid var(--border-strong)', background: 'var(--bg-surface)', color: 'var(--text-secondary)', cursor: 'pointer' };

  return (
    <div style={{ position: 'fixed', right: 20, bottom: 20, width: 320, background: 'var(--bg-surface)', border: '1px solid var(--border)', borderRadius: 12, boxShadow: 'var(--shadow-md)', padding: 14, zIndex: 4000 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <i className={`ti ti-${p.running ? 'loader-2' : complete ? 'circle-check' : 'player-pause'}`}
          style={{ fontSize: 16, color: complete ? '#1D9E75' : 'var(--accent)', animation: p.running ? 'ulspin 1s linear infinite' : undefined }} />
        <div style={{ flex: 1, fontWeight: 700, fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.rootName}</div>
        {p.running
          ? <button onClick={cancel} style={btn}>{t('fl_pause')}</button>
          : <button onClick={dismiss} style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: 'var(--text-tertiary)' }}><i className="ti ti-x" style={{ fontSize: 15 }} /></button>}
      </div>
      <div style={{ height: 8, borderRadius: 6, background: 'var(--c-gray-100)', overflow: 'hidden', marginBottom: 6 }}>
        <div style={{ height: '100%', width: `${pct}%`, background: complete ? '#1D9E75' : 'var(--accent)', transition: 'width 0.2s' }} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, fontSize: 11.5, color: 'var(--text-tertiary)' }}>
        <span>{p.done} / {p.total} ({pct}%)</span>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 170 }}>
          {complete ? (p.failed ? t('fl_skipped', { n: p.failed }) : t('fl_upload_done')) : p.current}
        </span>
      </div>
      <style>{'@keyframes ulspin { from { transform: rotate(0); } to { transform: rotate(360deg); } }'}</style>
    </div>
  );
}
